import gql from 'graphql-tag';
import moment from 'moment-timezone';

const getLandingPageAnalyticsQuery = gql`
  query GetLandingPageAnalytics(
    $createdAt: [String], 
    $organisationId: String!,
    $productShortName: String!, 
    $timezone: String!
  ) {
    getLandingPageAnalytics(
      createdAt: $createdAt,
      organisationId: $organisationId,
      productShortName: $productShortName,
      timezone: $timezone
    ) {
      stats
    }
  }
`;

const queryGetLandingPageAnalytics = (organisationId) => ({
  query: getLandingPageAnalyticsQuery,
  module: 'analytics',
  buildVariables: (data) => {
    const {
      createdAt,
      productShortName,
      timezone = moment.tz.guess()
    } = data;
    return {
      createdAt,
      organisationId,
      productShortName,
      timezone
    };
  }
});

export default queryGetLandingPageAnalytics;